import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { EditComponent } from '@app/common/templates/edit/edit.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TblKomponenteBezeichnerCreateComponent } from '../../tbl_komponente_bezeichner/create/create.component';

@Component({
	templateUrl: '../../../../common/templates/edit/edit.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/edit/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblKomponenteTypEditComponent extends EditComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
		@Optional() public config?: DynamicDialogConfig,
		@Optional() public ref?: DynamicDialogRef,

	) {
		super(accountService, breadcrumbService, confirmationService, crudService, dialogService, globals, messageService, router, translate, config, ref);

		this.apiUrl = 'TblKomponenteTyp';
		this.name = 'MENU.KOMPONENTE_TYP';
		this.url = '/' + PATH.KOMPONENTE_TYP;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: false, width: 400, readonly: false },
				{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
				{ type: 'object', key: 'vorgabe_bezeichner_id', label: 'komponente_bezeichner', required: false, width: 400, apiUrl: 'TblKomponenteBezeichner', createComponent: TblKomponenteBezeichnerCreateComponent },
				{ type: 'dropdown', key: 'gruppe_id', label: 'komponente_typ_gruppe', required: false },
				{ type: 'text', key: 'bemerkungen', required: false, width: 400 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.EDIT', routerLink: [this.url + '/' + PATH.EDIT + '/' + this.id] }
		]);
	}

	/* override */
	getOptions(): void {
		super.getOptions();
		this.options.gruppe_id = [];
		this.loading += 1;
		this.crudService.getVehicleComponentTypeGroups().then(res => {
			if(res && res.length > 0) {
				const o = [];
				res.forEach(dataEntry => {
					o.push({
						label: dataEntry['Label'],
						value: dataEntry['Value']
					});
				});
				this.options.gruppe_id = o;
			}
		}).catch(() => {
			// no exception expected...
		}).finally(()=> {
			this.loading -= 1;
		})
	}
}
